<template>
  <PageBackNav :teleport-slot-id="headerTeleportSlot" desktop-back-title="Back to Integrations" @back-nav="goBack" />

  <View justify="space-between" align="start" gap="lg" class="page-header">
    <View gap="lg" align="center">
      <IntegrationLogo :tile="tile" :alt="name" size="large" />

      <View direction="column" gap="xs">
        <View gap="sm" align="center" class="title-row">
          <Text variant="h1">{{ name }}</Text>
          <Badge v-if="connected" variant="green" label="Connected" size="small" />
        </View>
        <Text variant="body-large" color="secondary">{{ description }}</Text>
      </View>
    </View>

    <View gap="sm" align="center" class="page-actions">
      <slot name="actions" />
    </View>
  </View>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import { Badge, PageBackNav, Text, View } from '@tallo/design-system';
import { AppRouteNames } from '@tallo/investor/navigation';

import { headerTeleportSlot } from '../root/header-teleport-slot.const';
import IntegrationLogo from './integration-logo.vue';
import { IntegrationTile } from './integrations.config';

defineProps<{ tile: IntegrationTile; name: string; description: string; connected: boolean }>();

const router = useRouter();

function goBack() {
  router.push({ name: AppRouteNames.INVESTOR_INTEGRATIONS });
}
</script>

<style scoped lang="scss">
@import 'styles/mixins/layout.mixins';

.page-header {
  margin: var(--t-spacing-xs) 0 var(--t-spacing-lg);
}

@include screen-max-md {
  // The title and the buttons cannot share a line on a phone, so the buttons take their own.
  .page-header {
    flex-direction: column;
    align-items: stretch;
    gap: var(--t-spacing-md);
  }

  .page-actions {
    flex-wrap: wrap;
  }

  // Inline, the badge takes enough width to wrap the name onto a second line.
  .title-row {
    flex-wrap: wrap;
  }
}
</style>
